"use client";

import * as React from "react";
import { SideOverlayDrawer } from "./side-overlay-drawer";
import { cn } from "../../lib/utils";
import { Button } from "./button";
import { ProfileAvatar } from "./profile-avatar";

export interface ProfileDrawerItem {
  id: string;
  label: string;
  description?: string;
  icon: React.ReactNode;
  onClick?: () => void;
}

export interface ProfileDrawerSection {
  id: string;
  label: string;
  items: ProfileDrawerItem[];
}

export interface ProfileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  avatarUrl?: string;
  name: string;
  handle: string;
  sections: ProfileDrawerSection[];
  logoutLabel?: string;
  onLogout?: () => void;
}

export function ProfileDrawer({
  isOpen,
  onClose,
  avatarUrl,
  name,
  handle,
  sections,
  logoutLabel = "Log out",
  onLogout,
}: ProfileDrawerProps) {
  return (
    <SideOverlayDrawer isOpen={isOpen} onClose={onClose} title="More" onBack={onClose}>
      <div className="flex items-center gap-3">
        <ProfileAvatar
          src={avatarUrl}
          alt={name}
          className="h-12 w-12 rounded-full border border-black/10"
          fallbackClassName="bg-gray-100"
          logoClassName="h-[54%] w-[54%]"
        />
        <div>
          <p className="font-phudu text-lg font-bold text-[#101828]">{name}</p>
          <div className="font-plus-jakarta-sans text-sm text-[#475467]">{handle}</div>
        </div>
      </div>

      <div className="mt-6 space-y-6">
        {sections.map((section) => (
          <div key={section.id}>
            <p className="text-sm text-[#667085]">{section.label}</p>
            <div className="mt-2 border border-transparent">
              {section.items.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={item.onClick}
                  className="flex w-full items-center justify-between gap-3 rounded-lg px-1 py-3 text-left hover:bg-white"
                >
                  <div className="flex items-center gap-3">
                    <span className="text-[#667085]">{item.icon}</span>
                    <span className="font-semibold text-[#344054]">{item.label}</span>
                  </div>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.5 4.5L9.5 8L6.5 11.5" stroke="#98A2B3" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <Button variant="outline" size="lg" onClick={onLogout} className={cn("mt-8 w-full", !onLogout && "cursor-default")}>
        {logoutLabel}
      </Button>
    </SideOverlayDrawer>
  );
}
